import type {HTMLChakraProps} from '@chakra-ui/react';
import {useStyleConfig} from '@chakra-ui/react';
import {ChakraDiv} from '@linx-security/ui/utils/chakra-elements';
import type {PropsWithChildren, Ref} from 'react';
import {forwardRef} from 'react';

type DisplayProps = PropsWithChildren<
  {
    size?: `lg` | `md` | `sm`;
  } & HTMLChakraProps<'div'>
>;

export const Display = forwardRef((props: DisplayProps, ref: Ref<HTMLDivElement>) => {
  const {size, children} = props;
  const __css = useStyleConfig(`Display`, {size});
  return (
    <ChakraDiv __css={__css} ref={ref}>
      {children}
    </ChakraDiv>
  );
});
